import DateTime from './DateTime';
export type { DateTimeProps } from './DateTime.types';

export default DateTime;
